import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import AuctionBase from "../AuctionBase";
import React from "react";

import { getProto } from "../../../utils/proto/index";
import {
  Auction,
  AuctionKindGDAContinuous,
  AuctionKindGDADiscrete,
} from "../../../types";
import { getContinuousPurchasePrice } from "../../../lib/auctions/gda/continuous";
import { getDiscretePurchasePrice } from "../../../lib/auctions/gda/discrete";

const yieldPrice = (auction: Auction, statefulPurchaseQuantity: any) => {
  const epoch = new Date().getTime() / 1000;
  switch (auction.kind) {
    case AuctionKindGDAContinuous: {
      return getContinuousPurchasePrice(
        auction.starting_price,
        auction.decay_rate,
        auction.emission_rate,
        Math.floor(epoch) - auction.last_epoch,
        statefulPurchaseQuantity ? 1 : Number(statefulPurchaseQuantity),
        auction.priceFloor
      );
    }
    case AuctionKindGDADiscrete: {
      return getDiscretePurchasePrice(
        auction.starting_price,
        auction.decay_rate,
        auction.scale_factor,
        auction.sold,
        new Date().getTime() / 1000 - auction.start_epoch,
        !statefulPurchaseQuantity ? 1 : Number(statefulPurchaseQuantity),
        auction.priceFloor
      );
    }
  }
};

export const BigNumberAuction = ({
  auction,
  shopId,
  productId,
  now,
  endEpoch,
  onPlaceBid,
  customerId,
  shopLoginUrl,
  statefulPurchaseQuantity,
  setStatefulPurchaseQuantity,
  setVariant,
}) => {
  const [statefulBids, setStatefulBids] = useState([]);
  const isProto = useMemo(() => getProto(window.location.search), []);
  const [protoQty] = useState(10000);
  const [protoSold, setProtoSold] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(0);
  const [priceRising, setPriceRising] = useState(false);

  const clockRef = useRef();
  const priceRef = useRef();

  useEffect(() => {
    if (getProto(window.location.search)) {
      setStatefulBids([
        {
          price: 10,
        },
        {
          price: 20,
        },
        {
          price: 50,
        },
      ]);
    }
  }, []);

  const [timeLeft, setTimeLeft] = useState(
    endEpoch > now
      ? moment(endEpoch * 1000).unix() - moment(now * 1000).unix()
      : 0
  );

  useEffect(() => {
    setCurrentPrice(0);
    clearTimeout(clockRef.current);
    // @ts-ignore
    clockRef.current = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
      if (timeLeft % 2 === 0) {
        switch (!!getProto(window.location.search)) {
          case true: {
            // simulate new bids
            const _currentPrice = statefulBids.reduce(function (prev, current) {
              return prev.price > current.price ? prev : current;
            }).price;

            setCurrentPrice(
              Math.floor(
                Math.random() * (_currentPrice + 20 - _currentPrice + 1) +
                  _currentPrice
              )
            );
            break;
          }
          case false: {
            const price = yieldPrice(auction, statefulPurchaseQuantity);
            // @ts-ignore
            if (priceRef.current > price) {
              setPriceRising(false);
            } else {
              setPriceRising(true);
            }
            // @ts-ignore
            priceRef.current = price;
            setCurrentPrice(price);
            break;
          }
        }
      }
    }, 1000);
  }, [auction, clockRef, priceRef]);

  useEffect(() => {
    if (timeLeft > 0) {
      // @ts-ignore
      clockRef.current = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
        if (timeLeft % 2 === 0) {
          switch (!!getProto(window.location.search)) {
            case true: {
              // simulate new bids
              const _currentPrice = statefulBids.reduce(function (
                prev,
                current
              ) {
                return prev.price > current.price ? prev : current;
              }).price;

              setCurrentPrice(
                Math.floor(
                  Math.random() * (_currentPrice + 20 - _currentPrice + 1) +
                    _currentPrice
                )
              );
              break;
            }
            case false: {
              const price = yieldPrice(auction, statefulPurchaseQuantity);
              // @ts-ignore
              if (priceRef.current > price) {
                setPriceRising(false);
              } else {
                setPriceRising(true);
              }
              // @ts-ignore
              priceRef.current = price;
              setCurrentPrice(price);
              break;
            }
          }
        }
      }, 1000);
      return () => clearTimeout(clockRef.current);
    }
  }, [clockRef, timeLeft, statefulBids, priceRef]);

  return (
    <AuctionBase
      auction={auction}
      currentPrice={currentPrice}
      statefulPurchaseQuantity={statefulPurchaseQuantity}
      setStatefulPurchaseQuantity={setStatefulPurchaseQuantity}
      quantity={isProto ? protoQty : auction.quantity}
      sold={isProto ? protoSold : auction.sold}
      onBidClick={onPlaceBid}
      setVariant={setVariant}
      priceRising={priceRising}
    />
  );
};
